import { gql } from '@apollo/client';
import {
  graphql,
  SUPPORTED_LANGUAGE,
  SupportedLanguage,
} from '@xolv-mybrightlink/common';

const REMOTE_I18N_QUERY = gql`
  query i18n {
    i18n {
      en {
        key
        value
      }
      es {
        key
        value
      }
    }
  }
`;

export type RemoteI18nData = {
  [key in SupportedLanguage]: Record<string, string>;
};
type RemoteI18nDataResponse = {
  [key in SupportedLanguage]: { key: string; value: string }[];
};

export const fetchRemoteI18n = async (): Promise<RemoteI18nData> => {
  const response = await graphql.query<{ i18n: RemoteI18nDataResponse }>({
    query: REMOTE_I18N_QUERY,
  });
  return mapToRecord(response.data.i18n);
};

const mapToRecord = (data: RemoteI18nDataResponse): RemoteI18nData => {
  return SUPPORTED_LANGUAGE.reduce((result, language) => {
    const dataItems = data[language];
    result[language] = dataItems.reduce((obj, item) => {
      obj[item.key] = item.value;
      return obj;
    }, {} as Record<string, string>);
    return result;
  }, {} as RemoteI18nData);
};
